<template>
  <div class="list-modal-done h-card shadow">
    <div class="card-header">
      <div class="modal-title"></div>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
      <div class="p-3 small">
        <p>Для включения уведомлений через Telegram, необходимо привязать свой аккаунт к телеграм боту уведомлений. </p>
        <p>Для этого необходимо перейти в бота уведомлений и нажать кнопку "Запустить". После чего вернуться в расписание и установить галочку "Присылать уведомления о бронировании: в Telegram"</p>
        <p>Так же Вы можете привязать свой аккаунт к телеграм боту уведомлений на странице профиля своего аккаунта. <a href="/user/profile">Профиль</a></p>

      </div>
    </div>
    <div class="card-footer">
      <button class="ok-btn" @click="inBot">Перейти в бота</button>
      <button class="close-btn" @click="closeCmodal">Закрыть</button>
    </div>
  </div>
</template>
<script>
import {popModal} from "jenesius-vue-modal";


export default {
  name: 'InfoConnectTelegramBot',
  props: {
    url: String
  },
  methods: {
    closeCmodal() {
      popModal();
    },
    inBot() {
      window.location = this.url;
      // window.open(this.url, '_blank');
      popModal();
    },
  }
}
</script>
<style scoped>


.list-modal-done {
  width: 460px;
  //max-height: 100vh;
  container-name: list-modal-container;
  container-type: inline-size;
}

.list-modal-donel .card-body {
  padding: 0;
  overflow: auto;
  height: 400px;
  max-height: 95vh;
}

@container list-modal-container {
  .list-modal-done .card-body {
    height: 80cqh;
  }
}

</style>